import api from '@/api/api'

import Routes from '@/router/routes'

export default {
	name: 'clients',
	data () {
		return {
			routes : Routes
		}
	},
	methods : {},
	components : {},
	created () {}
}


// WEBPACK FOOTER //
// ./src/components/private/clients/script.js